export default class Environment {
    static isInDevelopmentMode() {
        return !process.env.NODE_ENV || process.env.NODE_ENV !== "production";
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/environment.ts